module.exports = __webpack_public_path__ + "static/media/circles.fe780488.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/circles.svg
// module id = 2617
// module chunks = 7